import { render, staticRenderFns } from "./WorkoutDetails.vue?vue&type=template&id=4ff3c56e&scoped=true&"
import script from "./WorkoutDetails.vue?vue&type=script&lang=js&"
export * from "./WorkoutDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutDetails.vue?vue&type=style&index=0&id=4ff3c56e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3c56e",
  null
  
)

export default component.exports